export default () => {
  const $modules = $('.module');
  
  $modules.each((i, el) => {
    const $el = $(el);

    $el.on('click', () => {
      if ($el.attr('data-active') === 'true') {
        $el.attr('data-active', false);
      } else {
        $el.attr('data-active', true);
      }
    });
    
    $(el).on('mouseenter', () => {
      $(el).attr('data-active', true);
    })
    
    $(el).on('mouseleave', () => {
      $(el).attr('data-active', false);
    })
  });
};